import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
  Avatar,
  Divider,
  CircularProgress,
  Link,
  Tabs,
  Tab,Button,DialogActions,Snackbar,DialogTitle,Dialog,DialogContent,Alert,
  Card,
  CardContent,
  CardHeader,
  Chip,
} from '@mui/material';
import Sidebar from '../components/sidebars/Sidebar';
import TopNav from '../components/top_bars/TopNav';
import StatisticsCards from '../components/top_bars/StatisticsCard';


const yesNo = (val) => (val === '1' ? 'Yes' : 'No');

const ProfileChecker = () => {
  const isMobile = useMediaQuery('(max-width:768px)');
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [profileData, setProfileData] = useState(null);
  const [securityUploads, setSecurityUploads] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState(0);

  const [confirmOpen, setConfirmOpen] = useState(false);
const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  useEffect(() => {
    const phoneNumber = localStorage.getItem('phoneNumber');

    const fetchProfile = async () => {
      try {
        const [profileRes, extraRes, uploadsRes] = await Promise.all([
          fetch(`${process.env.REACT_APP_API_BASE_URL}/get_full_profile.php?phone=${phoneNumber}`),
          fetch(`${process.env.REACT_APP_API_BASE_URL}/get_educationExperienceLastemp.php?phone=${phoneNumber}`),
          fetch(`${process.env.REACT_APP_API_BASE_URL}/get_uploads.php?phone=${phoneNumber}`),
        ]);

        const profileJson = await profileRes.json();
        const extraJson = await extraRes.json();
        const uploadsJson = await uploadsRes.json();

        if (profileJson.success) {
          setProfileData({
            ...profileJson.data,
            education: extraJson?.data?.education || [],
            experience: extraJson?.data?.experience || [],
            lastEmployer: extraJson?.data?.lastEmployer || [],
          });
        } else {
          setError('Staff profile does not exist');
        }

        if (uploadsJson?.data?.length > 0) {
          setSecurityUploads(uploadsJson.data[0]);
        }

      } catch (err) {
        console.error(err);
        setError('Network error');
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  const handleCertification = async () => {
  setConfirmOpen(false);
  try {
    const response = await fetch( `${process.env.REACT_APP_API_BASE_URL}/completion_state_.php`, {
   
        method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone: localStorage.getItem('phoneNumber') }), // Add phone if required
    });

    const result = await response.json();

   if (result.success) {
  setSnackbar({ open: true, message: result.message || 'Success!', severity: 'success' });
} else {
  const msg = result.message || 'Submission failed';
  setSnackbar({ open: true, message: msg, severity: 'error' });
}

  } catch (err) {
    setSnackbar({ open: true, message: 'Network error.', severity: 'error' });
  }
};

  const renderField = (label, value) => (
    <Typography variant="body1" sx={{ mb: 1 }}>
      <strong>{label}:</strong> {value || 'N/A'}
    </Typography>
  );

  const renderSection = (title, children) => (
    <Card variant="outlined" sx={{ mb: 3, borderRadius: 2 }}>
      <CardHeader 
        title={title} 
        titleTypographyProps={{ 
          variant: 'h6',
          sx: { 
            color: 'primary.main',
            fontWeight: 600,
          }
        }}
      />
      <Divider />
      <CardContent>
        {children}
      </CardContent>
    </Card>
  );

  const renderPersonalInfo = () => {
    const { personalInfo, additionalInfo, profilePhoto } = profileData;
    const fullName = `${personalInfo?.surname || ''} ${personalInfo?.other_names || ''}`;

    return (
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', p: 2 }}>
            <Avatar
              alt={fullName}
              src={`${process.env.REACT_APP_API_BASE_URL}/${profilePhoto}`}
              sx={{
                width: 160,
                height: 160,
                border: '3px solid',
                borderColor: 'primary.main',
                mb: 2,
              }}
            />
            <Typography variant="h6" align="center" gutterBottom>
              {fullName}
            </Typography>
            <Chip 
              label={personalInfo?.department || 'Department'} 
              color="primary" 
              variant="outlined" 
              sx={{ mb: 2 }}
            />
            <Typography variant="body2" color="text.secondary" align="center">
              {personalInfo?.email || 'Email not provided'}
            </Typography>
          </Card>
        </Grid>

        <Grid item xs={12} md={8}>
          {renderSection('Basic Information', (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                {renderField('Phone', personalInfo?.phone)}
                {renderField('Date of Birth', personalInfo?.date_of_birth)}
                {renderField('Marital Status', personalInfo?.marital_status)}
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderField('State of Origin', personalInfo?.state_of_origin)}
                {renderField('LGA', personalInfo?.lga)}
                {renderField('Country', personalInfo?.country)}
              </Grid>
              <Grid item xs={12}>
                {renderField('Residential Address', personalInfo?.residential_address)}
                {renderField('Permanent Address', personalInfo?.hometown_permanent_address)}
              </Grid>
            </Grid>
          ))}

          {additionalInfo && renderSection('Next of Kin Information', (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                {renderField('Next of Kin', additionalInfo.next_of_kin_name)}
                {renderField('Relationship', additionalInfo.relationship)}
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderField('Next of Kin Contact', additionalInfo.next_of_kin_contact)}
                {renderField('Health Status', additionalInfo.health_status)}
              </Grid>
              <Grid item xs={12}>
                {renderField('Next of Kin Address', additionalInfo.next_of_kin_address)}
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    );
  };

  const renderEducation = () => {
    const { education } = profileData;
    
    return education?.length > 0 && renderSection('Education Background', (
      <Grid container spacing={2}>
        {education.map((edu, idx) => (
          <React.Fragment key={idx}>
            <Grid item xs={12} sm={6}>
              {renderField('Primary School', `${edu.primary_school_name} — ${edu.primary_school_address}`)}
              {renderField('Secondary School', `${edu.secondary_school_name} — ${edu.secondary_school_address}`)}
            </Grid>
            <Grid item xs={12} sm={6}>
              {renderField('Tertiary School', `${edu.tertiary_school_name} — ${edu.tertiary_school_address}`)}
              {renderField('Status', edu.status)}
            </Grid>
            {idx < education.length - 1 && (
              <Grid item xs={12}>
                <Divider sx={{ my: 1 }} />
              </Grid>
            )}
          </React.Fragment>
        ))}
      </Grid>
    ));
  };

  const renderExperience = () => {
    const { experience, lastEmployer } = profileData;

    return (
      <>
        {experience?.length > 0 && renderSection('Work Experience', (
          <Grid container spacing={2}>
            {experience.map((exp, idx) => (
              <React.Fragment key={idx}>
                <Grid item xs={12} sm={6}>
                  {renderField('Type', exp.experience_type)}
                  {renderField('Years', exp.years_of_experience)}
                  {renderField('Self Evaluation', exp.self_evaluation)}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {renderField('Salary Expectation', `₦${parseFloat(exp.salary_expectation).toLocaleString()}`)}
                  {renderField('Status', exp.status)}
                </Grid>
                <Grid item xs={12}>
                  {renderField('Last Workplace 1', exp.last_workplace_one)}
                  {renderField('Last Workplace 2', exp.last_workplace_two)}
                </Grid>
                {idx < experience.length - 1 && (
                  <Grid item xs={12}>
                    <Divider sx={{ my: 1 }} />
                  </Grid>
                )}
              </React.Fragment>
            ))}
          </Grid>
        ))}

        {lastEmployer?.length > 0 && renderSection('Previous Employment', (
          <Grid container spacing={2}>
            {lastEmployer.map((emp, idx) => (
              <React.Fragment key={idx}>
                <Grid item xs={12} sm={6}>
                  {renderField('Employer', emp.previous_employer)}
                  {renderField('Job Title', emp.job_title)}
                  {renderField('Reason for Leaving', emp.reason_for_leaving)}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {renderField('Start Date', emp.employment_start_date)}
                  {renderField('End Date', emp.employment_end_date)}
                  {renderField('Contact', `${emp.employer_contact_name} — ${emp.employer_phone}`)}
                </Grid>
                {idx < lastEmployer.length - 1 && (
                  <Grid item xs={12}>
                    <Divider sx={{ my: 1 }} />
                  </Grid>
                )}
              </React.Fragment>
            ))}
          </Grid>
        ))}
      </>
    );
  };

  const renderSecurity = () => {
    if (!securityUploads) return null;

    return renderSection('Security & Documents', (
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          {renderField('Convicted Before', yesNo(securityUploads.convicted))}
          {renderField('Security Declaration', yesNo(securityUploads.security_declaration))}
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
            Uploaded Documents:
          </Typography>
          <Grid container spacing={2}>
            {Object.entries(securityUploads).map(([key, value]) => {
              if (key.endsWith('_upload') && value) {
                const label = key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
                return (
                  <Grid item xs={12} sm={6} md={4} key={key}>
                    <Card variant="outlined" sx={{ p: 1 }}>
                      <Typography variant="body2" sx={{ mb: 1 }}>
                        {label}
                      </Typography>
                      <Link
                        href={`${process.env.REACT_APP_API_BASE_URL}/${value}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        underline="hover"
                        color="primary"
                      >
                        View Document
                      </Link>
                    </Card>
                  </Grid>
                );
              }
              return null;
            })}
          </Grid>
        </Grid>
      </Grid>
    ));
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 0: return renderPersonalInfo();
      case 1: return renderEducation();
      case 2: return renderExperience();
      case 3: return renderSecurity();
      case 4:
  return (
    <Box sx={{ textAlign: 'center', mt: 4 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Confirm all documentation has been reviewed and is complete.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => setConfirmOpen(true)}
      >
        Certify Complete Documentation
      </Button>
    </Box>
  );

      default: return null;
    }
  };

  const renderProfileInfo = () => {
    if (loading) return <CircularProgress sx={{ display: 'block', mx: 'auto', mt: 4 }} />;
    if (error) return <Typography color="error" variant="h6" align="center" sx={{ mt: 4 }}>{error}</Typography>;
    if (!profileData) return <Typography variant="h6" align="center" sx={{ mt: 4 }}>No profile data found.</Typography>;

    return (
      <>
       <Tabs
  value={activeTab}
  onChange={(e, newValue) => setActiveTab(newValue)}
  variant={isMobile ? 'scrollable' : 'standard'}
  scrollButtons="auto"
  sx={{ mb: 3 }}
>
  <Tab label="Personal Info" />
  <Tab label="Education" />
  <Tab label="Experience" />
  <Tab label="Security & Docs" />
  <Tab label="Certification" /> {/* New tab */}
</Tabs>
        
        {renderTabContent()}
      </>
    );
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: '#f5f7fa' }}>
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <Box
        sx={{
          flexGrow: 1,
          p: isMobile ? 2 : 3,
          ml: isMobile ? 0 : sidebarOpen ? 30 : 5,
          maxWidth: '1400px',
          mx: 'auto',
          width: '100%',
        }}
      >
        <TopNav
          onLogout={() => {
            localStorage.removeItem('authToken');
            localStorage.removeItem('userProfile');
            localStorage.removeItem('phoneNumber');
          }}
          onNotificationClick={() => alert('You have new notifications!')}
          toggleSidebar={toggleSidebar}
        />
        <Box sx={{ mt: 3 }}>
          <StatisticsCards />
        </Box>
        {renderProfileInfo()}
      </Box>
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
  <DialogTitle>Confirm Certification</DialogTitle>
  <DialogContent>
    <Typography>Are you sure you want to certify complete documentation?</Typography>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
    <Button onClick={handleCertification} variant="contained" color="primary">
      Yes, I'm sure
    </Button>
  </DialogActions>
</Dialog>

<Snackbar
  open={snackbar.open}
  autoHideDuration={6000}
  onClose={() => setSnackbar({ ...snackbar, open: false })}
>
  <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
    {snackbar.message}
  </Alert>
</Snackbar>

    </Box>
  );
};

export default ProfileChecker;